module.exports = __webpack_public_path__ + "img/69.93cb40cb.svg";